/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIEmployeeUser
 */
export interface APIEmployeeUser {
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeUser
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIEmployeeUser
     */
    isStaff?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIEmployeeUser
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the APIEmployeeUser interface.
 */
export function instanceOfAPIEmployeeUser(value: object): value is APIEmployeeUser {
    return true;
}

export function APIEmployeeUserFromJSON(json: any): APIEmployeeUser {
    return APIEmployeeUserFromJSONTyped(json, false);
}

export function APIEmployeeUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmployeeUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'isStaff': json['is_staff'] == null ? undefined : json['is_staff'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
    };
}

export function APIEmployeeUserToJSON(value?: APIEmployeeUser | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'is_staff': value['isStaff'],
        'is_active': value['isActive'],
    };
}

